/* Office search renders nearby offices on the listing and map.
 * Highlighted cards omit the separator that floated behind their top edges.
 * Keywords that match no place fall back to the default location instead of failing the page. */
import { app, Component } from 'apprun';
import { paginateAssets, sortAgentsOrAgencies, PageSize, setSearchResultValues, getAgencyLink, moveTo, $, showLoading, distance, checkMapList } from './utility';
import { getGeoCode, geocodePlace, getAllOffices } from './model/agency';
import Agency from './template/search-agency-template';
import searchAgencyForm from './searchAgencyForm';
import './osm-map.ts';
import { lang } from './Txlat';
import PageControl from './pageControl';
import InquiryForm from './inquiry-form';
declare const L;

const filterOffices = function (offices, name) {

  if (name) {
    offices = offices.filter(p => p.name.toLowerCase().includes(name.toLowerCase()));
  } else {
    offices = [];
  }

  // offices = offices.filter(p => p.latitude && p.longitude &&
  //   p.latitude >= lowerBounds.lat && p.latitude <= upperBounds.lat && p.longitude >= lowerBounds.lng && p.longitude <= upperBounds.lng);

  return offices;

};

function getMapAgencies(agencies) {

  // TODO: define popup thumbnail
  const thumbnail = agency => `${agency.thumbnail ? '<div class="item-header"><a target=agent' + agency.property_id + ' href="' + agency.url + '"><img class="img-fluid" src="' + agency.thumbnail + '" alt="' + agency.title + '"/></a></div>' : ''}`;

  const url = agency => lang.get() === 'fr' ? getAgencyLink(agency, 'fr') : getAgencyLink(agency, 'en');

  const popup = agency => `<div class="item-wrap">
${thumbnail(agency)}
<div class="item-body flex-grow-1">
<h2 class="item-title">
<a target=agent${agency.id} href=${url(agency)}>${agency.name}</a>
</h2>
<ul class="list-unstyled item-info">
${agency.address ? '<li class="item-address">' + agency.address + '</li>' : ''}
${agency.phone ? '<li class="item-type">' + agency.phone + '</li>' : ''}
</ul>
</div>
</div>`;

  return agencies.map(agency => ({
    id: agency.id,
    title: agency.name,
    lat: agency.latitude,
    lng: agency.longitude,
    marker: '/wp-content/themes/houzez/img/map/pin-agency.png',
    retinaMarker: '/wp-content/themes/houzez/img/map/pin-agency.png',
    popup: popup(agency)
  }));
}

export default class agencySearchResult extends Component {

  view = (state) => {
    if (!state.agencies) { return; }

    app.render($('#resultFound'), <PageControl page={state.page} total={state.agencies.length} size={PageSize} event='/gotoPage' type='agency' isMlsDeleted />);

    return <>
      <div>
        <div id="houzez_ajax_container">
          <div class="card-deck">
            {state.highlighedProp &&
              <div style='width:100%'><Agency agency={state.highlighedProp} hightlight={true} />
              </div>}
            {state.pageAgencies.map(a => <Agency agency={a} hightlight={false} />)}
          </div>
        </div>

        {state.agencies.length ? <PageControl page={state.page} total={state.agencies.length} size={PageSize} event='/gotoPage' type='agency' isMlsDeleted /> : <></>}
        <p></p>
      </div>
    </>;
  };

  update = {
    '#': async () => {

      checkMapList();
      const params = new URLSearchParams(location.search);
      const keyword = params.get('keyword') ? params.get('keyword').trim() : '';
      const name = params.get('name') ? params.get('name').trim() : '';
      const sortBy = params.get('sortby') ? params.get('sortby') : '';
      setSearchResultValues(keyword, name, sortBy);

      const bounds = geocodePlace(await getGeoCode(keyword)).geometry.viewport;
      app.run('/map-set-boundary', bounds);

      // const ags = await getAgenciesNearby(keyword, name);
      // const agencies = sortAgentsOrAgencies(ags, sortBy);
      // const page = params.get('page') ? params.get('page') : '1';
      // const pageAgencies = paginateAssets(agencies, page);
      // app.run('map', getMapAgencies(agencies), false);
      // return { all_agencies: agencies, agencies, pageAgencies, page: page, sortby: sortBy, };
    },

    '/map-load-list': async (state, lowerBounds, upperBounds) => {
      showLoading('#resultFound');

      const name = ($('[name="name"]') as HTMLInputElement).value;
      const location = ($('[name="keyword"]') as HTMLInputElement).value;

      state.all_agencies = await getAllOffices();
      let filterdOffices = filterOffices(state.all_agencies, name);
      let ignoreMapMove = true;

      if (filterdOffices.length === 0) {
        filterdOffices = state.all_agencies.filter(p => p.latitude >= lowerBounds.lat && p.latitude <= upperBounds.lat && p.longitude >= lowerBounds.lng && p.longitude <= upperBounds.lng);
      } else {
        ignoreMapMove = false;
      }

      const centerLat = (lowerBounds.lat + upperBounds.lat) / 2;
      const centerLng = (lowerBounds.lng + upperBounds.lng) / 2;
      filterdOffices = filterdOffices.map(a => ({
        ...a,
        distance: distance(centerLat, centerLng, a.latitude, a.longitude),
      }));
      state.agencies = sortAgentsOrAgencies(filterdOffices, state.sortBy);
      state.page = 1;
      state.pageAgencies = paginateAssets(state.agencies, state.page);
      state.unfilteredAgencies = state.all_agencies;

      if (state.searchName === name && state.searchLocation === location) {
        ignoreMapMove = true;
      } else {
        state.searchName = name;
        state.searchLocation = location;
      }

      app.run('map', getMapAgencies(state.agencies), ignoreMapMove);
      return state;

    },

    '/map-refresh-list': (state, bounds) => {
      if (!state.all_agencies) { return; }
      showLoading('#resultFound');
      const agencies = state.all_agencies.filter(p => bounds.contains(L.latLng(p.latitude, p.longitude)));

      state.agencies = agencies;
      state.page = 1;
      state.agencies = sortAgentsOrAgencies(state.agencies, state.sortby);
      state.pageAgencies = paginateAssets(state.agencies, 1);
      state.unfilteredAgencies = state.agencies;
      return state;

    },

    '/sortAgentsOrAgencies': async (state) => {
      const s = $('#ajax_sort_properties') as HTMLInputElement;
      state.sortby = s.value;
      state.agencies = sortAgentsOrAgencies(state.agencies, s.value);
      state.page = 1;
      state.pageAgencies = paginateAssets(state.agencies, 1);
      return state;
    },

    '/highlight-card': (state, map_agent) => {
      moveTo('.card:first-of-type');
      let highlighedProp = '';
      if (map_agent) {
        highlighedProp = state.all_agencies.find(p => p.id === map_agent.id);
      }
      return { ...state, highlighedProp };
    },

    '/set_map_view': async (state, v) => {

      const url = new URL(window.location.href);
      const last_map_view = url.searchParams.get('map_view');

      if (v !== last_map_view) {
        url.searchParams.set('map_view', v);
        window.history.pushState({}, '', url.href);
      }

      return state;
    },

    '/gotoPage': (state, targetPageNumber) => {
      state.page = targetPageNumber;
      state.pageAgencies = paginateAssets(state.agencies, targetPageNumber);
      return state;
    },
  };

}

new agencySearchResult().start('.listing-view');
new searchAgencyForm().start('.advanced-search.advanced-search-half-map');
new InquiryForm({ isPopup: true }).start('.mobile-property-form .modal-body');
window.addEventListener('resize', checkMapList);